import React from 'react';
const TEMPLATE_REGEXP = /{\w+}/g;
export type TemplateValue = string | number | boolean;
export type TemplateValues = Record<string, TemplateValue>;
type Props = {
  className?: string;
  dataTestId?: string;
  staticClassName?: string;
  template: string;
  values: TemplateValues;
  valuesClassName?: Record<string, string>;
};

function escapeCurlyBrackets(string: string): string {
  return (string.match(/\w+/) || [''])[0];
}

function generateTemplateNodes({
  staticClassName,
  template = '',
  values = {},
  valuesClassName = {},
}: {
  staticClassName?: string;
  template: string;
  values: TemplateValues;
  valuesClassName?: Record<string, string>;
}): Array<string | Node> {
  const templateWithoutVariables = template.split(TEMPLATE_REGEXP) || [];
  const templateVariables = template.match(TEMPLATE_REGEXP) || [];
  return templateWithoutVariables.reduce((templateNodes, staticValue, index, array) => {
    if (index === array.length - 1) {
      return templateNodes.concat([
        staticClassName && staticValue ? (
          <span className={staticClassName} key={staticValue}>
            {staticValue}
          </span>
        ) : (
          staticValue
        ),
      ]);
    }

    const variableName = escapeCurlyBrackets(templateVariables[index]);
    return templateNodes.concat([
      staticClassName && staticValue ? (
        <span className={staticClassName} key={staticValue}>
          {staticValue}
        </span>
      ) : (
        staticValue
      ),
      encapsulateWithClassName(values[variableName], variableName, valuesClassName[variableName]),
    ]);
  }, []);
}

function encapsulateWithClassName(value: TemplateValue = '', keyName: string, className?: string) {
  const v = value ? value.toString() : '';
  return className && v ? (
    <span key={keyName} className={className}>
      {v}
    </span>
  ) : (
    v
  );
}

export const TemplateString = ({
  className,
  dataTestId,
  staticClassName,
  template = '',
  values = {},
  valuesClassName,
}: Props) =>
  template ? (
    <span className={className} data-testid={dataTestId}>
      {generateTemplateNodes({
        staticClassName,
        template,
        values,
        valuesClassName,
      })}
    </span>
  ) : null;
